module.exports = new __parcel__URL__("cornershop-new-web.5ea86973.webp").toString();